import React from 'react'
import PropTypes from 'prop-types'

const CommonTextLabel = ({ children, title, className, isRequired, onClick }) => (
  <label className={`common label ${className}`} htmlFor={title} onClick={onClick}>
    {title || children}
    {isRequired && <span className="red ml1">*</span>}
  </label>
)

CommonTextLabel.defaultProps = {
  title: null,
  className: '',
  children: null,
  isRequired: false,
  onClick: null,
}

CommonTextLabel.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  onClick: PropTypes.func,
}

export default CommonTextLabel
